module.exports = __webpack_public_path__ + "static/img/7-3.8b4a0a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/7-3.jpg
// module id = 8TN6
// module chunks = 0